import { Component, EventEmitter, Input, Output, SimpleChanges, LOCALE_ID, Inject } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-constants';
import { AdditionTabs, TrainingDataTabs, SessionContentType } from '../training-page.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { DatePipe, formatDate } from '@angular/common';


@Component({
  selector: 'app-training-survey',
  templateUrl: './training-survey.component.html',
  styleUrls: ['./training-survey.component.scss', '../training-page.component.scss']
})
export class TrainingSurveyComponent {
  //Constants
  additionTabs = AdditionTabs;
  trainingDataTabs = TrainingDataTabs;
  contentType = SessionContentType;
  GlobalConstants = GlobalConstants;

  //Data Variables
  @Input() courseId: string = '';
  @Input() courseData: any
  @Input() fromRating: boolean = false;
  @Input() ratingType: string = '';
  @Input() selectedSurveyID: string = '';
  @Input() fromImpact: boolean = false;

  surveys: any[] = [];
  startDate: Date = new Date('09-09-2023');
  today: Date = new Date()

  blockOptions: any[] = [
    { name: this.translate('Preview status'), value: 'Preview' },
    { name: this.translate('Block status'), value: 'Block' },
    { name: this.translate('Unblock status'), value: 'Unblock' }
  ];

  translate(value: string) {
    const pipe: TranslatorPipe = new TranslatorPipe();
    return pipe.transform(value);
  }

  //Toogling Variables
  @Input() updateSurveyData: any;
  @Input() addNewSurvey: boolean = false;
  @Input() trainingTypeId: string = "";
  @Output() mainSurveyUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectedSurvey: any;

  surveyForm: FormGroup = this.fb.group({
    start_date: ['', Validators.required],
    end_date: ['', Validators.required],
    surveyId: ['', Validators.required],
    video_mode: ['Unblock'],
  });

  //Input Variables

  //Output Variables
  @Output() sessionCreated: EventEmitter<boolean> = new EventEmitter();
  @Output() sessionSelected: EventEmitter<any> = new EventEmitter();

  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private fb: FormBuilder,
    @Inject(LOCALE_ID) private locale: string,
  ) { }

  ngOnInit() {
    this.createsurveyForm()
    this.getSurveys().then(() => {
      if (this.selectedSurveyID != '') {
        this.selectedSurvey = this.surveys.find(survey => survey._id === this.selectedSurveyID);
      }
    });

    console.log("this.selectedSurvey", this.selectedSurvey)

    this.addNewSurvey = !!this.updateSurveyData;

    this.surveyForm.get('start_date')?.valueChanges.subscribe(e => {
      this.startDate = e;
    })


  }

  ngOnChanges(simpleChange: SimpleChanges) {
    if (simpleChange['updateSurveyData']) {
      console.log('UPDATE DATA', simpleChange['updateSurveyData'].currentValue)
      this.updateSurveyData = simpleChange['updateSurveyData'].currentValue;
      if (!!this.updateSurveyData) {
        this.surveyForm.patchValue(this.updateSurveyData);
        this.selectedSurvey = { ...this.updateSurveyData, _id: this.updateSurveyData.parentId };
      }
    }

    if (this.selectedSurveyID != '') {
      this.selectedSurvey = this.surveys.find(survey => survey._id === this.selectedSurveyID);
    }
  }

  createsurveyForm() {
    console.log('COURSE DATA IN SURVEY', this.courseData)
    this.surveyForm = this.fb.group({
      start_date: [new Date(this.courseData?.start_date), Validators.required],
      end_date: [new Date(this.courseData?.end_date), Validators.required],
      surveyId: ['', Validators.required],
      video_mode: ['Unblock'],
    });

    if (this.fromRating || this.fromImpact) {

      this.setValidators(['surveyId']);
      this.clearValidators(['start_date', 'end_date', 'video_mode']);
      this.clearValues(['start_date', 'end_date', 'video_mode']);
      this.surveyForm?.updateValueAndValidity();
    }
  }

  setValidators(fields: string[]) {
    fields.forEach(field => {
      const control = this.surveyForm.get(field);
      if (control) {
        control.setValidators(Validators.required);
        control.updateValueAndValidity();
      }
    });
  }

  clearValidators(fields: string[]) {
    fields.forEach(field => {
      const control = this.surveyForm.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  clearValues(fields: string[]) {
    fields.forEach(field => {
      const control = this.surveyForm.get(field);
      if (control) {
        control.setValue(null);
      }
    });
  }

  isFieldError(field: string) {
    const control = this.surveyForm.get(field);
    if (control?.dirty && control.touched && control.errors?.['required']) {
      return true
    }
    return false
  }

  surveyUpdated(data: any) {
    this.updateSurveyData = null;
    this.addNewSurvey = false;
    this.mainSurveyUpdated.emit(true)
  }


  markAllFieldsTouchedAndDirty(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control?.markAsTouched();
      control?.markAsDirty();
    });
  }

  // get Surveys
  private async getSurveys(): Promise<void> {
    let tag;
    if (this.fromRating) {
      if (this.fromImpact) {
        tag = 'TAG_24'
      } else {
        tag = 'TAG_18'
      }
    } else {
      tag = 'TAG_1';
    }
    let res = await this.dataService.getData('survey/' + tag + '?trainingTypeId=' + this.trainingTypeId);
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.surveys = res.data.map((item: any) => {

      return {
        _id: item._id,
        name: item.name,
        type: item.type,
        comments: item.comments,
        surveyTitle: item.name,
        description: item.comments,
        status: item.status,
        trainingTypeId: item.trainingTypeId,
        questions: item.questions,
        startDate: item.startDate,
        endDate: item.endDate,
      };
    });
  }

  async createSurveySession() {
    console.log('SELECTED S', this.selectedSurvey)


    if (!this.surveyForm.valid) {
      this.markAllFieldsTouchedAndDirty(this.surveyForm);
      return
    }

    let formValues = this.surveyForm.getRawValue()
    this.selectedSurvey.cloneParentId = formValues.surveyId;
    const { _id, ...survey } = this.selectedSurvey;
    console.log('DATE TIME',formValues);
    survey.start_time = formatDate(formValues.start_date, "dd-MM-YYYYTHH:mm:ss", this.locale)
    survey.end_time = formatDate(formValues.end_date, "dd-MM-YYYYTHH:mm:ss", this.locale);
    survey.start_time = this.parseDateTime(survey.start_time);
    survey.end_time = this.parseDateTime(survey.end_time);
    survey.start_time.setHours(survey.start_time.getHours(), survey.start_time.getMinutes(), survey.start_time.getSeconds());
    survey.end_time.setHours(23, 59, 59, 999);
    const clonedSurveyId: any = await this.cloneSurvey(survey);
    let surveySessionData = {
      "title": this.selectedSurvey.surveyTitle,
      "date": this.today,
      "sessionType": this.contentType.Survey,
      "surveyId": clonedSurveyId,
      "description": this.selectedSurvey.description,
      "start_time": survey.start_time,
      "end_time": survey.end_time,
      "video_mode": formValues.video_mode,
      "parentId": _id
    }

    console.log('surveySessionData', surveySessionData)

    this.createSession(surveySessionData)
    this.selectedSurvey = null;
  }

  parseDateTime(dateTimeString: string): Date {
    const [datePart, timePart] = dateTimeString.split('T');
    const [day, month, year] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart ? timePart.split(':').map(Number) : [0, 0, 0];
    return new Date(year, month - 1, day, hours || 0, minutes || 0, seconds || 0);
  }

  async selectSurvey(surveyId: string) {
    let data: any = {
      'surveyId': surveyId,
      'ratingType': this.ratingType
    }
    this.sessionSelected.emit(data)
  }

  addedNewSurveySession() {
    //TODO:Implement this
    this.ngOnInit()
    this.addNewSurvey = false;
  }

  async createSession(data: any) {
    data.courseId = this.courseId;
    console.log('SESSION CREATE CALLED', data, this.courseId)

    try {
      let method = 'POST';
      if (!!this.updateSurveyData) {
        method = 'PUT';
        data._id = this.updateSurveyData._id
      }
      let res = await this.dataService.postData('session', data, method)
      if (!res.error) {
        this.sessionCreated.emit(true)
        return
      }
      console.log(res.msg)
    } catch (e) {
      console.log(e)
    }
  }

  async cloneSurvey(survey: any) {
    try {
      let res = await this.dataService.postData('survey', survey);
      if (res.error) {
        return;
      }
      return res.data._id;
    } catch (error) {
      console.log(error);
    }
  };

  async openAddQuestion(survey: any) {
    let url, id;
    let queryParams: any = { courseId: this.courseId };
    url = `/survey/add-question`
    id = survey._id;

    if (this.fromImpact) {
      queryParams['fromImpact'] = true;
    }

    if (url) {
      this.router.navigate([url, id], { queryParams: queryParams })
    }
  }
}
